module.exports = __webpack_public_path__ + "img/large2.bc5ce8ef.jpg";